import { render, staticRenderFns } from "./OurTeam.vue?vue&type=template&id=6c7e0455&scoped=true&"
import script from "./OurTeam.vue?vue&type=script&lang=js&"
export * from "./OurTeam.vue?vue&type=script&lang=js&"
import style0 from "./OurTeam.vue?vue&type=style&index=0&id=6c7e0455&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c7e0455",
  null
  
)

export default component.exports